import { Wrapper, Container } from './styles'
import { HeaderComponent, ContentTextComponent } from './containers'
import { Helmet } from 'react-helmet'

export function NoticeDetailsView() {
  return (
    <Wrapper>
      <Helmet>
        <title>Nomos - Notícia</title>
      </Helmet>
      <Container maxWidth="lg">
        <HeaderComponent />
        <ContentTextComponent />
      </Container>
    </Wrapper>
  )
}
